import { DASHBOARD_URL } from '@/constants/routes'

export default function isMenuItemActive(pathname, menuPath) {
  if (!menuPath || menuPath === '#') {
    return false
  }

  const normalizedPathname = pathname.replace(/\/$/, '') || '/'
  const normalizedMenuPath = menuPath.replace(/\/$/, '') || '/'

  if (normalizedMenuPath === DASHBOARD_URL) {
    return normalizedPathname === DASHBOARD_URL
  }

  return normalizedPathname === normalizedMenuPath
    || normalizedPathname.startsWith(`${normalizedMenuPath}/`)
}
